module.exports = __webpack_public_path__ + "static/media/linkedin.4ebed8f3.svg";